import { render, staticRenderFns } from "./incoming-member-requests.vue?vue&type=template&id=6825f29c"
import script from "./incoming-member-requests.vue?vue&type=script&lang=js"
export * from "./incoming-member-requests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports